"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var newCustomerToCgElement = document.getElementById('NewCustomerToCustomerGroup');

    if (newCustomerToCgElement && !newCustomerToCgElement.selectRegistered) {
        $(newCustomerToCgElement).on('select2:select', newCustomerSelected());
    }

    var fileInput = document.getElementById('customerGroupCustomerFileInput');
    if (fileInput && !fileInput.changeRegistered) {
        fileInput.addEventListener('change', fileSelected);
        fileInput.changeRegistered = true;
    }

    function fileSelected() {
        try {
            var fileReader = new FileReader();
            fileReader.onload = function () {
                try {
                    var CustomerGroupId = getCustomerGroupId();
                    var CustomerReferences = fileReader.result.match(/[A-z0-9]{4,20}/g);
                    var bodyObject = { CustomerGroupId: CustomerGroupId, CustomerReferences: CustomerReferences };
                    new _ajaxHelper2.default().sendRequest('/Customer/ImportCustomersToGroup', importComplete, bodyObject);
                } catch (e) {
                    console.error("Error parsing file on import customers for customer group. Method: fileSelected - nested method.", e);
                }
            };
            fileReader.readAsText(this.files[0]);
        } catch (e) {
            console.error("Error reading file on import customers for customer group. Method: fileSelected", e);
        }
    }

    function importComplete(httpRequest, responseObject) {
        var errorMessage = "Error processing response from import process. Method: importComplete.";
        try {
            if (!responseObject || !responseObject.success || !responseObject.result) {
                logErrorAndMessage(errorMessage, httpRequest, responseObject);
                return;
            }

            var message = Resx.Messages.ImportCompleted;
            message += getImportItemsToMessage(responseObject.result.successfullyImported, Resx.Messages.ImportCompleteSuccessfulItems);
            message += getImportItemsToMessage(responseObject.result.notFound, Resx.Messages.ImportCompleteNotFoundItems);
            message += getImportItemsToMessage(responseObject.result.failed, Resx.Messages.ImportCompleteFailedItems);
            message += getImportItemsToMessage(responseObject.result.existing, Resx.Messages.ImportCompleteExistingItems);
            var customClass = message.length > 1000 ? 'swal-wide' : null;

            (0, _sweetalert2.default)({ text: message, title: Resx.Common.OK, icon: 'success', customClass: customClass }, function () {
                window.location.reload();
            });
        } catch (exception) {
            logErrorAndMessage(errorMessage, httpRequest, responseObject, exception);
        }
    }

    function getImportItemsToMessage(itemsArray, messageFormat) {
        if (!itemsArray || !Array.isArray(itemsArray) || itemsArray.length === 0 || !messageFormat) return '';
        var limit = 100;
        var overLimit = itemsArray.length > limit;
        var limitedArray = overLimit ? itemsArray.slice(0, limit) : itemsArray;

        var references = limitedArray.filter(function (f) {
            return typeof f.reference === 'string' || f.customer && f.customer.reference;
        }).map(function (i) {
            return i.reference || i.customer.reference;
        }).join(', ');
        return "\n" + messageFormat.replace('{0}', itemsArray.length).replace('{1}', references) + (overLimit ? '...' : '');
    }

    function logErrorAndMessage(message, httpRequest, responseObject, exception) {
        (0, _sweetalert2.default)({ text: Resx.Common.Error, title: Resx.Common.AjaxError, icon: 'error' });
        console.error(message, httpRequest, responseObject, exception);
    }

    function getCustomerGroupId() {
        return _common2.default.convertIntSafe(_common2.default.getElementPropertySafe('.customer-group-buttons input#Id'));
    }

    function newCustomerSelected() {
        return function (event) {
            try {
                var data = event.params.data;
                // select2 fires select event multiple times, condition bellow prevents that

                if (newCustomerToCgElement.lastId === data.id) return;

                var CustomerGroupId = getCustomerGroupId();
                var savingObject = { CustomerGroupId: CustomerGroupId, CustomerId: data.id };

                var ajaxHelper = new _ajaxHelper2.default();
                ajaxHelper.sendRequest('/Customer/AddNewCustomerToGroup', function (httpRequest, responseObject) {
                    return newCustomerSelectedSaved(httpRequest, responseObject, data);
                }, savingObject);

                newCustomerToCgElement.lastId = data.id;
                newCustomerToCgElement.selectRegistered = true;
            } catch (e) {
                console.error("Error on saving customer group to customer relation. Method: newCustomerSelected", event, e);
            }
        };
    }

    function newCustomerSelectedSaved(httpRequest, responseObject, selectedCustomerData) {
        try {
            _commonSaverLibrary.commonSaverLibrary.saveDone(httpRequest, responseObject, { commonSaveAfterSaveUrl: window.location.href });
            console.log(httpRequest, responseObject, selectedCustomerData);
        } catch (e) {
            console.error("Error after saving customer group to customer relation. Method: newCustomerSelectedSaved", event, e);
        }
    }
};

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

var _ajaxHelper = require("../libraries/ajaxHelper");

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _sweetalert = require("sweetalert");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _commonSaverLibrary = require("../libraries/commonSaverLibrary");

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'Common');


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/customerGroup.js
// module id = 410
// module chunks = 0